import { DeviceOrigin } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private _device: DeviceOrigin | undefined;

  public get device(): DeviceOrigin | undefined {
    return this._device;
  }
  public set device(value: DeviceOrigin) {
    this._device = value;
  }
}
